import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

export interface ISwitchOptionsV2Option<TValue extends string = string> {
  value: TValue;
  label: string;
  /** Caminhos dos ícones (asset local) para o estado ativo/inativo desta opção — a cor do ícone muda junto com o fundo da pílula. */
  icon?: { active: string; inactive: string };
}

interface ISwitchOptionsV2Props<TValue extends string = string>
  extends Omit<ComponentPropsWithoutRef<"div">, "onChange"> {
  options: ISwitchOptionsV2Option<TValue>[];
  value: TValue;
  onChange: (value: TValue) => void;
  name?: string;
}

export const SwitchOptionsV2 = <TValue extends string = string>({
  options,
  value,
  onChange,
  name = "switch-options-v2",
  className,
  ...rest
}: ISwitchOptionsV2Props<TValue>) => {
  return (
    <div
      className={twMerge(
        "flex rounded-full border border-solid border-[#e5e5ea] shadow-[0_8px_24px_0_rgba(0,0,0,0.08)] p-[10px]",
        className,
      )}
      {...rest}
    >
      {options.map((option) => {
        const isActive = option.value === value;

        return (
          <label
            key={option.value}
            className={twMerge(
              "flex-1 flex items-center justify-center gap-[10px] rounded-full px-5 py-[10px] text-base cursor-pointer",
              isActive ? "bg-[#20332f] text-white" : "bg-transparent text-[#2d2d2d]",
            )}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={isActive}
              onChange={() => onChange(option.value)}
              className="sr-only"
            />
            {option.icon && (
              <img
                src={isActive ? option.icon.active : option.icon.inactive}
                alt=""
                className="h-4 w-4"
              />
            )}
            {option.label}
          </label>
        );
      })}
    </div>
  );
};
